import React from 'react';

import {observer} from "mobx-react";
import {BaseProps} from "../../../../../../infrastructure/models/props/base-props";
import {GameCenterHeaderModuleController} from "../../game-center-header-module.controller";
import {GameCenterHeaderDetailsCompetitor} from "./competitor/game-center-header.details.competitor";
import {GameCenterHeaderModuleDetailsStatus} from "./status/game-center-header-module.details.status";
import styles from "../../styles/game-center-header.module.scss";
import classNames from "classnames";

export class GameCenterHeaderModuleDetailsProps extends BaseProps {
  controller: GameCenterHeaderModuleController;
}

export const GameCenterHeaderModuleDetails = observer(({controller}: GameCenterHeaderModuleDetailsProps) => {
 const homeCompetitorProps = {
   controller,
   isHomeTeam: true
 }

  return (
    <div className={classNames(styles.competitors_and_scores)}>
      <GameCenterHeaderDetailsCompetitor {...homeCompetitorProps}/>
      <GameCenterHeaderModuleDetailsStatus controller={controller}/>
      <GameCenterHeaderDetailsCompetitor controller={controller}/>
    </div>
  )
});
